import { render, staticRenderFns } from "./detail-2-columns-row.vue?vue&type=template&id=3e0f36c8&"
import script from "./detail-2-columns-row.vue?vue&type=script&lang=js&"
export * from "./detail-2-columns-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e0f36c8')) {
      api.createRecord('3e0f36c8', component.options)
    } else {
      api.reload('3e0f36c8', component.options)
    }
    module.hot.accept("./detail-2-columns-row.vue?vue&type=template&id=3e0f36c8&", function () {
      api.rerender('3e0f36c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/pageParts/detail-2-columns-row.vue"
export default component.exports